import React, { useContext, createContext } from 'react';
import { getDoneJobs } from 'utils/network/http';
import usePaginationFetchData from 'hooks/usePaginationFetchData/usePaginationFetchData';

export const doneJobsContext = createContext();

export const ProvideDoneJobs = ({ children }) => {
  const doneJobs = useProvideDoneJobs();
  return (
    <doneJobsContext.Provider value={doneJobs}>
      {children}
    </doneJobsContext.Provider>
  );
};

export const useDoneJobs = () => {
  return useContext(doneJobsContext);
};

const useProvideDoneJobs = () => {
  const {
    isLoadingInitialData,
    error,
    isLoadingMore,
    hasMore,
    data,
    size,
    setSize,
  } = usePaginationFetchData({ fetchFunc: getDoneJobs });

  return {
    isLoadingInitialData,
    error,
    isLoadingMore,
    hasMore,
    doneJobs: data || [],
    size,
    setSize,
  };
};
